import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as CANNON from 'cannon-es'
import {RGBELoader} from "three/addons";

/**
 * Debug
 */
const debugObject = {}

debugObject.create = () =>
{
    for (let i = 0; i < 5; i++) createSphere(
        Math.max(0.1, Math.random() * 0.5 + 0.1),
        {
            x: (Math.random() - 0.5) * 30,
            y: 15,
            z: (Math.random() - 0.5) * 30
        }
    )

    for (let i = 0; i < 5; i++) createBox(
        Math.random()*2,
        Math.random()*2,
        Math.random()*2,
        {
            x: (Math.random() - 0.5) * 30,
            y: 15,
            z: (Math.random() - 0.5) * 30
        }
    )

}

debugObject.createBox = () =>
{
    createBox(
        Math.random()*2,
        Math.random()*2,
        Math.random()*2,
        {
            x: (Math.random() - 0.5) * 30,
            y: 15,
            z: (Math.random() - 0.5) * 30
        }
    )
}

debugObject.createSphere = () =>
{
    createSphere(
        Math.max(0.1, Math.random() * 0.5 + 0.1),
        {
            x: (Math.random() - 0.5) * 30,
            y: 15,
            z: (Math.random() - 0.5) * 30
        }
    )
}

// Reset
debugObject.reset = () =>
{
    for(const object of objectsToUpdate)
    {
        // Remove body
        world.removeBody(object.body)

        // Remove mesh
        scene.remove(object.mesh)
    }
    
    objectsToUpdate.splice(0, objectsToUpdate.length)
}




/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


/**
 * Physics
 */
const world = new CANNON.World()
world.broadphase = new CANNON.SAPBroadphase(world)
world.allowSleep = true
world.gravity.set(0, - 9.82, 0)

// Default material
const defaultMaterial = new CANNON.Material('default')
const defaultContactMaterial = new CANNON.ContactMaterial(
    defaultMaterial,
    defaultMaterial,
    {
        friction: 0.05,
        restitution: 0.7
    }
)
world.defaultContactMaterial = defaultContactMaterial

// Three.js mesh


const floorGeometry = new THREE.BoxGeometry(10, 0.1, 10)
const material = new THREE.MeshPhysicalMaterial({
    metalness: 0,
    roughness: 0,
    transmission: 1,
    ior: 10,
    thickness: 0,
})

const mesh = new THREE.Mesh(floorGeometry, material)
mesh.position.y = 0.5

const mesh2 = new THREE.Mesh(floorGeometry, material)
mesh2.position.y = 0.5
mesh2.position.x = 10
mesh2.rotation.z = Math.PI * 0.25

const mesh3 = new THREE.Mesh(floorGeometry, material)
mesh3.position.y = 0.5
mesh3.position.x = -10
mesh3.rotation.z = - Math.PI * 0.25

const mesh4 = new THREE.Mesh(floorGeometry, material)
mesh4.position.y = 0.5
mesh4.position.z = 10
mesh4.rotation.x = - Math.PI * 0.25

const mesh5 = new THREE.Mesh(floorGeometry, material)
mesh5.position.y = 0.5
mesh5.position.z = -10
mesh5.rotation.x =  Math.PI * 0.25


scene.add(mesh, mesh2, mesh3,mesh4, mesh5)

// Cannon.js body
const shape = new CANNON.Box(new CANNON.Vec3(5, 0.55, 5))

const body = new CANNON.Body({
    mass: 0,
    position: new CANNON.Vec3(0, 0, 0),
    shape: shape,
    material: defaultMaterial
})


const body1 = new CANNON.Body({
    mass: 0,
    position: new CANNON.Vec3(10, 0, 0),
    shape: shape,
    material: defaultMaterial
})

body1.quaternion.setFromAxisAngle(new CANNON.Vec3(0, 0, 1), Math.PI * 0.25)

const body2 = new CANNON.Body({
    mass: 0,
    position: new CANNON.Vec3(-10, 0, 0),
    shape: shape,
    material: defaultMaterial
})

body2.quaternion.setFromAxisAngle(new CANNON.Vec3(0, 0, 1), -Math.PI * 0.25)

const body3 = new CANNON.Body({
    mass: 0,
    position: new CANNON.Vec3(0, 0, 10),
    shape: shape,
    material: defaultMaterial
})

body3.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), -Math.PI * 0.25)

const body4 = new CANNON.Body({
    mass: 0,
    position: new CANNON.Vec3(0, 0, -10),
    shape: shape,
    material: defaultMaterial
})

body4.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), Math.PI * 0.25)


world.addBody(body)
world.addBody(body1)
world.addBody(body2)
world.addBody(body3)
world.addBody(body4)

/**
 * Utils
 */
let objectsToUpdate = []
// Create sphere
const sphereGeometry = new THREE.SphereGeometry(1, 20, 20)

const createSphere = (radius, position) =>
{

    const sphereMaterial = new THREE.MeshPhysicalMaterial({
        metalness: 0,
        roughness: 0,
        transmission: 0.9,
        ior: 10,
        thickness: 0,
        color: new THREE.Color(Math.random(), Math.random(), Math.random())
    })

    // Three.js mesh
    const mesh = new THREE.Mesh(sphereGeometry, sphereMaterial)
    mesh.scale.set(radius, radius, radius)
    mesh.position.copy(position)
    scene.add(mesh)

    // Cannon.js body
    const shape = new CANNON.Sphere(radius)

    const body = new CANNON.Body({
        mass: 1,
        position: new CANNON.Vec3(0, 3, 0),
        shape: shape,
        material: defaultMaterial
    })
    body.position.copy(position)
    world.addBody(body)

    // Save in objects
    objectsToUpdate.push({ mesh, body })
}


// Create box
const boxGeometry = new THREE.BoxGeometry(1, 1, 1)
const createBox = (width, height, depth, position) =>
{

    const boxMaterial = new THREE.MeshPhysicalMaterial({
        metalness: 0,
        roughness: 0,
        transmission: 0.9,
        ior: 10,
        thickness: 0,
        color: new THREE.Color(Math.random(), Math.random(), Math.random())
    })


    // Three.js mesh
    const mesh = new THREE.Mesh(boxGeometry, boxMaterial)
    mesh.scale.set(width, height, depth)
    mesh.position.copy(position)
    scene.add(mesh)

    // Cannon.js body
    const shape = new CANNON.Box(new CANNON.Vec3(width * 0.5, height * 0.5, depth * 0.5))

    const body = new CANNON.Body({
        mass: 1,
        position: new CANNON.Vec3(0, 5, 0),
        shape: shape,
        material: defaultMaterial
    })
    body.position.copy(position)
    world.addBody(body)

    // Save in objects
    objectsToUpdate.push({ mesh, body })
}

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 2.1)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.left = - 7
directionalLight.shadow.camera.top = 7
directionalLight.shadow.camera.right = 7
directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(5, 5, 5)
scene.add(directionalLight)

const rgbeLoader = new RGBELoader();
rgbeLoader.load('./textures/environmentMap/qwantani_moon_noon_puresky_2k.hdr', texture => {
    texture.mapping = THREE.EquirectangularReflectionMapping;
    scene.background = texture;
    scene.environment = texture;
})

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(- 15, 10, 15)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

controls.minDistance = 5
controls.maxDistance = 25

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()
let oldElapsedTime = 0

document.querySelector('.stop').addEventListener('click', stopRain);
document.querySelector('.start').addEventListener('click', startRain);
document.querySelector('.reset').addEventListener('click', debugObject.reset);
document.querySelector('.many').addEventListener('click', debugObject.create);
document.querySelector('.sphere').addEventListener('click', debugObject.createSphere);
document.querySelector('.box').addEventListener('click', debugObject.createBox);

function stopRain () {
    isRain = false
    console.log(1)
}

function startRain() {
    isRain = true
    console.log(2)
}


let isRain = true


setInterval(() => {
    if(isRain){
        Math.random() > 0.5 ? debugObject.createSphere() : debugObject.createBox()
    }
}, 150)




const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - oldElapsedTime
    oldElapsedTime = elapsedTime

    // Update physics
    world.step(1 / 60, deltaTime, 3)

    objectsToUpdate = objectsToUpdate.filter(object => {
        if (object.body.position.y < -100) {
            world.removeBody(object.body)
            scene.remove(object.mesh)
            return false
        }

        object.mesh.position.copy(object.body.position)
        object.mesh.quaternion.copy(object.body.quaternion)
        return true
    })



    // debugObject.create()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()